export const MESSAGES = {
  server_error: 'The system is currently down due to maintenance. Please try again later.',
  error_500: 'Internal Server Error',
};

export const VARIABLES = {
  // userSession: 'cpcb-user',
  userName: 'user_name',
  name: 'name',
  userId: 'user_id',
  email: 'email',
  userRole: 'role',
  org: 'org',
};
export const CONSTANTS = {
  COMPLAINT_DESCRIPTION: "Complaint Description",
  GENERAL_INFO: "General Info",
  CATEGORY: "Category",
  SOURCE: "Source",
  open_count: "Received",
  under_inv_count: "In_Progress",
  resolved_count: "Resolved",
  ulb_count:"Ulb's",
  ro_count:"Ro's",
  state_count:"States",
  admin_count:"States / UT's",
  escalated_count:"Escalated",
  Received: "open",
  In_Progress: "in_progress",
  Resolved: "resolved",
  Ulb:"ulb",
  Ro:"ro",
  State:"state",
  Admin:"admin",
  Escalated:"escalated",
  COMMENT_VALIDATION: "Please enter remarks to submit",
  ACTION_DETAILS:"Details of Action Taken",
  COMMENTS:"Comments",
  SUBMIT:"Submit",
  FILES_ATTACHED:"Images related to this complaint",
  IMAGES:"Images",
  PDF_DOWNLOAD:"Download Pdf",
  NAME:"Name",
  PHONE:"Mobile Number",
  LOCATION:"Location",
  MAP_VIEW:"View In Map",
  RECEIVED_2_DAYS:"Received within 2 days",
  RECEIVED_4_DAYS:"Received within 4 days",
  RECEIVED_MORE_4_DAYS:"Received within 7 days",
  SLA_BREACHED:"SLA breached (More than 7 days)",
};

export const ICON_DETAILS = {
  "open_count": "open",
  "under_inv_count": "inProgress",
  "resolved_count": "checkmark",
  "ulb_count":"enterprise",
  "ro_count":"enterprise",
  "state_count":"enterprise",
  "escalated_count":"escalated",
  "admin_count":"enterprise",
  // "open_count": faEnvelopeOpen,
  // "under_inv_count": faBarsProgress,
  // "resolved_count": faCircleCheck
}

export const TOASTER_TIMEOUT = 2000;